module.exports = __webpack_public_path__ + "static/media/5.09db4bac.jpg";